export default {
  '布展时间': '布展时间',
  '发票开始申请时间': '发票开始申请时间',
  '预租时间': '预租时间',
  '开展时间': '开展时间',
  '参展商报到': '参展商报到',
  '楣板禁止修改时间': '楣板禁止修改时间',
  '承建商报到': '承建商报到',
  '撤展时间': '撤展时间',
  '特装审图': '特装审图',
  '展会费用缴纳': '报馆费用缴纳',
  '租赁服务': '租赁服务',
  '押金退款': '押金退款',
  '发票申请': '发票申请',
  '提交楣板': '标摊楣板',
  '提交会刊': '提交会刊',
  '保险购买': '保险购买',
  '车证': '车证',
  '施工证': '施工证',
  '展位概况': '展位概况',
  '此手机号已注册,修改信息失败': '此手机号已注册,修改信息失败',

  '特装提交报图资料': '特装提交报图资料',
  '展位缴纳展会费用入口': '场地管理费、展台押金、加班费等',
  '施工证申请入口': '施工证申请入口',
  '展具租赁、用水用电网络': '展具租赁、用水用电网络',
  '展会期间车辆通行证申请': '展会期间车辆通行证申请',
  '申请退还押金入口': '申请退还押金入口',
  '申请开具发票入口': '申请开具发票入口',
  '提交楣板资料': '提交楣板资料',
  '提交会刊资料': '提交会刊资料',
  '提供展会保险购买服务': '提供展会保险购买服务',
  '查看展位详细信息': '查看展位详细信息',

  //租赁类型
  '展具': '展具',
  '用电': '用电',
  '用气': '用气',
  '给水、排水': '给水、排水',
  '网络、电话': '网络、电话',
  '其它': '其它',
  '标摊用电': '标摊用电',
  '椅子': '椅子',
  '凳子': '凳子',
  '高脚椅': '高脚椅',
  '沙发': '沙发',
  '办公椅': '办公椅',
  '扶手椅': '扶手椅',
  '户外座椅': '户外座椅',
  '冰柜': '冰柜',

  "特装": "特装",
  "标摊": "标摊",

  "2": "特装",
  "1": "标摊",

  "必缴": "必缴",
  "非必缴": "非必缴",

  "展会费用": "展会费用",
  "已缴纳": "已缴纳",
  "存在未缴": "存在未缴",
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/dataI18n/main.js